import { Icon, useIsMobile } from '@yes.technology/react-toolkit'
import { useRef } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { NavigationSliderSecondaryProps } from './NavigationSliderSecondary.types'
import {
  CenterText,
  MainContainer,
  NavigationTitleContainer,
  SliderButton
} from './styles'

function NavigationSliderSecondary({
  options,
  currentIndex,
  onNextClick,
  onPrevClick,
  disabled,
  disabledArrow,
  justifyContent = 'center'
}: NavigationSliderSecondaryProps) {
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const currentOption = options[currentIndex]
  const prevButtonRef = useRef<HTMLButtonElement>(null)
  const nextButtonRef = useRef<HTMLButtonElement>(null)

  const isArrowDisabled = (arrow: 'prev' | 'next') => {
    return disabled || disabledArrow === arrow
  }

  if (!currentOption) {
    return null
  }

  const { value, color, Adornment } = currentOption
  const previousLabel = `${value} - ${t('navigation-slider.previous')}`
  const nextLabel = `${value} - ${t('navigation-slider.next')}`

  return (
    <MainContainer $justifyContent={justifyContent}>
      <SliderButton
        onClick={onPrevClick}
        type='button'
        aria-label={previousLabel}
        disabled={isArrowDisabled('prev')}
        ref={prevButtonRef}
        onMouseEnter={() => prevButtonRef?.current?.focus()}
        onMouseLeave={() => prevButtonRef?.current?.blur()}
      >
        <Icon
          iconName={
            isArrowDisabled('prev')
              ? 'NavigationLeftDisabled'
              : 'NavigationLeft'
          }
          icSize={isMobile ? 'semiLarge' : 'extraLarge'}
          icColor='blackText'
          nonFocusable
        />
      </SliderButton>

      <NavigationTitleContainer>
        <CenterText $color={color}>{value}</CenterText>
        {Adornment && Adornment}
      </NavigationTitleContainer>

      <SliderButton
        onClick={onNextClick}
        type='button'
        aria-label={nextLabel}
        disabled={isArrowDisabled('next')}
        ref={nextButtonRef}
        onMouseEnter={() => nextButtonRef?.current?.focus()}
        onMouseLeave={() => nextButtonRef?.current?.blur()}
      >
        <Icon
          iconName={
            isArrowDisabled('next')
              ? 'NavigationRightDisabled'
              : 'NavigationRight'
          }
          icSize={isMobile ? 'semiLarge' : 'extraLarge'}
          icColor='blackText'
          nonFocusable
        />
      </SliderButton>
    </MainContainer>
  )
}

export default NavigationSliderSecondary
